import React from "react";
import { cn } from "@/lib/utils";
import { PackageOpen } from "lucide-react";

export const EmptyState = ({
    title = "Nothing here yet",
    hint = "",
    action,
    icon: Icon = PackageOpen,
    className,
    testId,
}) => (
    <div
        className={cn(
            "flex flex-col items-center justify-center rounded-2xl border border-dashed border-neutral-300 bg-white/60 px-6 py-16 text-center",
            className,
        )}
        data-testid={testId || "empty-state"}
    >
        <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-2xl nest-gradient text-white nest-shadow">
            <Icon size={28} strokeWidth={2.25} />
        </div>
        <h3 className="text-lg font-semibold text-neutral-900">{title}</h3>
        {hint ? (
            <p className="mt-1 max-w-sm text-sm text-neutral-500">{hint}</p>
        ) : null}
        {action ? <div className="mt-6">{action}</div> : null}
    </div>
);

export default EmptyState;
